import { all } from 'redux-saga/effects';
import employeeTypeSaga from './employeeSaga';
import provinceTypeSaga from './provinceSaga';
import viewManagerSaga from './viewManagerSaga';
import viewConciergeSaga from './viewConciergeSaga';
import empSaga from './empSaga';
import siteSaga from './siteSaga';
import  visitorTypeSaga from './visitorTypeSaga';
import visitorSaga from './visitorSaga';
import  dashboardSaga from './dashboardSaga';


export default function* rootSaga() {
    yield all([
        employeeTypeSaga(),
        provinceTypeSaga(),
        viewManagerSaga(),
        viewConciergeSaga(),
        empSaga(),
        siteSaga(),
        visitorTypeSaga(),
        visitorSaga(),
        dashboardSaga(),

       
    ]);
}
            